/**
 * Created by fers on 27.04.16.
 */
import React from 'react';
import PropTypes from 'prop-types';
import {ParentBox, relayWrap} from '../../box-utils/ParentBox.react.js';
import Error from '../system/Error.react.js';
import {sendError} from '../../../app/errorDisplayer';
import BoxDecorator from '../../box-utils/BoxDecorator.react';
import {FormattedMessage} from 'react-intl';

class AddRelation extends ParentBox {

    static handlerName = "add-relation";

    static propTypes = {
        isPreview: PropTypes.bool,
        viewWithData: PropTypes.object.isRequired,
    };

    getIcon() {
        return "dativery";
    }

	getServiceName() {
		return "Dativery";
	}

    render() {
        try {
            let relationDef = this.props.viewWithData.view.relationDef;

            return (
                <BoxDecorator icon={this.getIcon()} isPreview={this.props.isPreview} title={this.getServiceName()}>
                    <div style={{padding: '5px'}}>
                        <h4><FormattedMessage defaultMessage="Attach" id="relation.attach" /> {relationDef ? relationDef.name : ''}</h4>
                        <div className="input-group">
                            <span className="input-group-addon">$</span>
                            <input aria-label="Amount (to the nearest dollar)" className="form-control" type="text" />
                            <span className="input-group-btn">
                                <button className="btn btn-default"><span className="fa fa-search" /></button>
                            </span>
                        </div>
                    </div>
                </BoxDecorator>
            );
        } catch (e) {
            sendError(e);
            return (<Error error={e} />);
        }
    }
}

export default relayWrap(AddRelation);
